import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';

type Props = {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  noPad?: boolean;
  sx?: any;
};

export const GlassCard: React.FC<Props> = ({ children, title, subtitle, noPad, sx = {} }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        background: theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.04)'
          : '#ffffff',
        backdropFilter: 'blur(12px)',
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
        borderRadius: 4,
        transition: 'all 0.25s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 8px 24px rgba(0, 0, 0, 0.3)'
            : '0 8px 24px rgba(0, 0, 0, 0.12)',
          borderColor: theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.12)'
            : 'rgba(0, 0, 0, 0.12)',
        },
        ...sx,
      }}
    >
      {(title || subtitle) && (
        <Box sx={{ px: 3, pt: 3, pb: title ? 1 : 2 }}>
          {title && (
            <Typography variant="h4" sx={{ fontWeight: 700, mb: subtitle ? 0.5 : 0 }}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      <CardContent sx={{ p: noPad ? 0 : 3, '&:last-child': { pb: 3 } }}>
        {children}
      </CardContent>
    </Card>
  );
};
